export type BalanceGameItem = {
  question: string;
  leftLabel: string;
  rightLabel: string;
};

export const balanceGameItems: BalanceGameItem[] = [
  {
    question: "주말 하루를 통째로 즐긴다면 어느 쪽이 더 좋은가요?",
    leftLabel: "집에서 푹 쉬기",
    rightLabel: "밖에서 하루 종일 놀기",
  },
  {
    question: "평생 하나만 더 자주 먹어야 한다면 무엇을 고를 건가요?",
    leftLabel: "밥",
    rightLabel: "면",
  },
  {
    question: "더 끌리는 여행 스타일은 어느 쪽인가요?",
    leftLabel: "계획 빡빡한 여행",
    rightLabel: "즉흥 여행",
  },
  {
    question: "콘텐츠를 즐길 때 더 선호하는 것은 무엇인가요?",
    leftLabel: "영화 몰아보기",
    rightLabel: "드라마 정주행",
  },
  {
    question: "업무나 공부를 할 때 더 편한 환경은 무엇인가요?",
    leftLabel: "조용한 공간",
    rightLabel: "약간의 배경 소음",
  },
  {
    question: "친구와 약속이 잡히면 더 마음이 가는 쪽은 무엇인가요?",
    leftLabel: "맛집 탐방",
    rightLabel: "카페 수다",
  },
  {
    question: "하루 동안 하나만 쓸 수 있다면 무엇이 더 아쉬울까요?",
    leftLabel: "이어폰",
    rightLabel: "휴대폰 충전기",
  },
  {
    question: "취미를 새로 시작한다면 어떤 쪽이 더 끌리나요?",
    leftLabel: "몸 쓰는 취미",
    rightLabel: "집중하는 정적인 취미",
  },
  {
    question: "여행을 떠난다면 어느 스타일이 더 끌리나요?",
    leftLabel: "도시 여행",
    rightLabel: "자연 여행",
  },
  {
    question: "하루 종일 먹어야 한다면 어떤 쪽이 더 좋나요?",
    leftLabel: "매운 음식",
    rightLabel: "달달한 음식",
  },
  {
    question: "카페에서 시간을 보낸다면 어떤 쪽이 더 좋은가요?",
    leftLabel: "창가 자리",
    rightLabel: "구석 조용한 자리",
  },
  {
    question: "친구들과 놀 때 더 선호하는 흐름은 무엇인가요?",
    leftLabel: "계획된 코스",
    rightLabel: "즉흥적으로 이동",
  },
  {
    question: "집중이 더 잘 되는 환경은 어느 쪽인가요?",
    leftLabel: "완전한 정적",
    rightLabel: "잔잔한 음악",
  },
  {
    question: "식사 후 디저트를 고른다면 더 자주 고르는 쪽은 무엇인가요?",
    leftLabel: "케이크",
    rightLabel: "아이스크림",
  },
  {
    question: "쉬는 날 더 끌리는 활동은 무엇인가요?",
    leftLabel: "늦잠 자기",
    rightLabel: "아침 일찍 나가기",
  },
  {
    question: "팀플이나 협업에서 더 편한 역할은 어느 쪽인가요?",
    leftLabel: "아이디어 내기",
    rightLabel: "정리하고 마무리하기",
  },
  {
    question: "사진을 남길 때 더 선호하는 것은 무엇인가요?",
    leftLabel: "풍경 사진",
    rightLabel: "인물 사진",
  },
  {
    question: "영상을 볼 때 더 손이 가는 것은 무엇인가요?",
    leftLabel: "짧고 빠른 영상",
    rightLabel: "길고 몰입감 있는 영상",
  },
  {
    question: "모임에서 더 편한 순간은 언제인가요?",
    leftLabel: "소수로 깊게 대화할 때",
    rightLabel: "여럿이 같이 떠들 때",
  },
  {
    question: "쇼핑을 한다면 어느 쪽이 더 가깝나요?",
    leftLabel: "오프라인 매장",
    rightLabel: "온라인 주문",
  },
  {
    question: "메모를 할 때 더 선호하는 방식은 무엇인가요?",
    leftLabel: "손글씨 메모",
    rightLabel: "휴대폰 메모",
  },
  {
    question: "운동을 한다면 더 끌리는 것은 무엇인가요?",
    leftLabel: "혼자 하는 운동",
    rightLabel: "같이 하는 운동",
  },
  {
    question: "비 오는 날 더 생각나는 선택은 무엇인가요?",
    leftLabel: "따뜻한 국물",
    rightLabel: "전과 막걸리",
  },
  {
    question: "집 꾸미기를 한다면 더 먼저 챙기고 싶은 것은 무엇인가요?",
    leftLabel: "조명",
    rightLabel: "가구",
  },
  {
    question: "연락 습관으로 더 가까운 쪽은 무엇인가요?",
    leftLabel: "짧게 자주 연락",
    rightLabel: "길게 한 번에 연락",
  },
];
